"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
var Mode;
(function (Mode) {
    Mode[Mode["Light"] = 0] = "Light";
    Mode[Mode["Dark"] = 1] = "Dark";
    Mode[Mode["Unset"] = 2] = "Unset";
})(Mode = exports.Mode || (exports.Mode = {}));
exports.useLightSwitch = () => {
    const darkMedia = window.matchMedia('(prefers-color-scheme: dark)');
    const lightMedia = window.matchMedia('(prefers-color-scheme: light)');
    const [dark, setDark] = react_1.useState(darkMedia.matches);
    const [light, setLight] = react_1.useState(lightMedia.matches);
    const unsed = !dark && !light;
    react_1.useEffect(() => {
        const darkFn = (e) => { setDark(e.matches); };
        const lightFn = (e) => { setLight(e.matches); };
        darkMedia.addListener(darkFn);
        lightMedia.addListener(lightFn);
        return () => {
            darkMedia.removeListener(darkFn);
            lightMedia.removeListener(lightFn);
        };
    }, []);
    return unsed
        ? Mode.Unset
        : dark
            ? Mode.Dark
            : Mode.Light;
};
exports.modeSelector = (mode, { light, dark, unset }) => {
    switch (mode) {
        case Mode.Light:
            return light;
        case Mode.Dark:
            return dark;
        case Mode.Unset:
            return unset;
    }
};
exports.useModeSelector = ({ light, dark, unset }) => {
    const mode = exports.useLightSwitch();
    return exports.modeSelector(mode, { light, dark, unset });
};
